export default window.appConfig
